import { useQuery } from '@apollo/client';
import * as React from 'react';
import { Redirect, useLocation } from 'react-router';
import { IS_LOGGED_IN } from '../../../client/__graphql__/queries/admin/isLoggedIn';
import { AdminContext } from '../containers/Admin';
import { getAdminClient } from '../layout/admin/AdminApolloClient';

const client = getAdminClient();

export const Protected: React.FC = ({ children }) => {
  const location = useLocation();
  const { setAdminState, adminState } = React.useContext(AdminContext);

  const { data, loading, refetch } = useQuery(IS_LOGGED_IN, {
    fetchPolicy: 'network-only',
    client: client,
    ssr: false,
    onCompleted: ({ isLoggedIn }) => {
      if (isLoggedIn?.status) {
        setAdminState({
          ...adminState,
          loggedIn: {
            status: isLoggedIn.status,
            urltag: isLoggedIn.urltag,
            user: isLoggedIn.user,
          },
        });
      } else {
        setAdminState({
          ...adminState,
          loggedIn: {
            status: false,
            urltag: '',
            user: '',
          },
        });
      }
    },
  });

  React.useEffect(() => {
    refetch();
  }, [location.pathname]);

  if (loading) {
    return <>Loading..</>;
  }

  if (data?.isLoggedIn?.status === true) {
    return <>{children}</>;
  } else {
    return <Redirect to="/admin" />;
  }
};
